/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAnswer } from './ControlAnswer';
import {
    ControlAnswerFromJSON,
    ControlAnswerFromJSONTyped,
    ControlAnswerToJSON,
} from './ControlAnswer';

/**
 * 
 * @export
 * @interface ControlSaveAnswerResponse
 */
export interface ControlSaveAnswerResponse {
    /**
     * 
     * @type {ControlAnswer}
     * @memberof ControlSaveAnswerResponse
     */
    answer: ControlAnswer;
}

/**
 * Check if a given object implements the ControlSaveAnswerResponse interface.
 */
export function instanceOfControlSaveAnswerResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "answer" in value;

    return isInstance;
}

export function ControlSaveAnswerResponseFromJSON(json: any): ControlSaveAnswerResponse {
    return ControlSaveAnswerResponseFromJSONTyped(json, false);
}

export function ControlSaveAnswerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSaveAnswerResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'answer': ControlAnswerFromJSON(json['answer']),
    };
}

export function ControlSaveAnswerResponseToJSON(value?: ControlSaveAnswerResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'answer': ControlAnswerToJSON(value.answer),
    };
}

